export default __webpack_public_path__ + "static/media/Opensea-Logomark-White.8510c826.svg";